import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { isNewLineUpPlanProfile } from './feature-gate-helper';

export const useIsSellerOnFeatureGatedPlanProfile = () => {
  const planProfileId = useSelector((state) => {
    const subscriptionPlanInfo = Global.selectSellerSubscriptionPlanInfo(state);
    return subscriptionPlanInfo?.planProfileId;
  });

  return isNewLineUpPlanProfile(planProfileId);
};
